import axios from "axios";
import { API_URL } from "../constants";
import { getFirebaseIdToken } from "../auth";

export async function getClientIP() {
    // API64 returns IPv6, API returns IPv4
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;  // Public IP
}

export async function getNearbyHearts(setNearbyHearts) {
    try{
        const ip = await getClientIP();
        console.log("Client IP: ", ip);

        const token = await getFirebaseIdToken();
        const headers = token
            ? { Authorization: `Bearer ${token}` }
            : {};  // return empty headers if no user

        // Call API Server to list all hearts that have the same IP as the client
        const response = await axios.get(
            `${API_URL}/hearts/ip/${ip}`, 
            {headers}
        );
        console.log(response.data)

        // Filter out the hearts that already have owners
        response.data = response.data.filter((heart) => heart.owner === 'None');
        console.log("Filtered list:", response.data)

        setNearbyHearts(response.data);
    } catch (error) {
        console.error('Error getting nearby hearts:', error);
        throw error;
    }
}